module.exports = __webpack_public_path__ + "img/3x.49790e3.jpg";